export function initLevelTest() {
  const openTestButtons = document.querySelectorAll('#open-level-test, .button--secondary[href="#"]')
  const testPopup = document.getElementById("levelTestPopup")
  const testOverlay = testPopup?.querySelector(".popup__overlay")
  const testClose = testPopup?.querySelector(".popup__close")

  if (!testPopup) return

  // Open test popup
  openTestButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      if (button.textContent.includes("Пройти тест") || button.id === "open-level-test") {
        e.preventDefault()
        testPopup.classList.add("active")
        document.body.style.overflow = "hidden"
        resetTest()
      }
    })
  })

  // Close test popup
  const closeTestPopup = () => {
    testPopup.classList.remove("active")
    document.body.style.overflow = ""
  }

  if (testOverlay) {
    testOverlay.addEventListener("click", closeTestPopup)
  }

  if (testClose) {
    testClose.addEventListener("click", closeTestPopup)
  }

  // Test logic
  let currentQuestion = 1
  const totalQuestions = 20
  const answers = {}

  const questions = testPopup.querySelectorAll(".level-test__question")
  const prevButton = testPopup.querySelector("#prevQuestion")
  const nextButton = testPopup.querySelector("#nextQuestion")
  const finishButton = testPopup.querySelector("#finishTest")
  const progressFill = testPopup.querySelector(".level-test__progress-fill")
  const currentQuestionSpan = testPopup.querySelector(".level-test__current")
  const resultScreen = testPopup.querySelector(".level-test__result")

  function updateProgress() {
    const progress = (currentQuestion / totalQuestions) * 100
    progressFill.style.width = `${progress}%`
    currentQuestionSpan.textContent = currentQuestion
  }

  function showQuestion(questionNumber) {
    questions.forEach((q) => q.classList.remove("active"))
    const targetQuestion = testPopup.querySelector(`.level-test__question[data-question="${questionNumber}"]`)
    if (targetQuestion) {
      targetQuestion.classList.add("active")
    }

    // Update button states
    prevButton.disabled = questionNumber === 1

    if (questionNumber === totalQuestions) {
      nextButton.style.display = "none"
      finishButton.style.display = "block"
    } else {
      nextButton.style.display = "block"
      finishButton.style.display = "none"
    }

    updateProgress()
  }

  function resetTest() {
    currentQuestion = 1
    Object.keys(answers).forEach((key) => delete answers[key])

    // Uncheck all radio buttons
    testPopup.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = false
    })

    // Hide result screen
    resultScreen.classList.remove("active")

    // Show first question
    showQuestion(1)
  }

  function calculateLevel() {
    const correctAnswers = {
      q1: "2",
      q2: "2",
      q3: "3",
      q4: "3",
      q5: "2",
      q6: "3",
      q7: "3",
      q8: "2",
      q9: "4",
      q10: "2",
      q11: "3",
      q12: "3",
      q13: "3",
      q14: "2",
      q15: "2",
      q16: "3",
      q17: "2",
      q18: "3",
      q19: "2",
      q20: "3",
    }

    let score = 0
    Object.keys(correctAnswers).forEach((key) => {
      if (answers[key] === correctAnswers[key]) {
        score++
      }
    })

    const percentage = (score / totalQuestions) * 100

    let level = "A1"
    let description = "Beginner - вы владеете базовыми навыками общения на английском языке."

    if (percentage >= 90) {
      level = "C1"
      description = "Advanced - вы свободно владеете английским языком на продвинутом уровне."
    } else if (percentage >= 75) {
      level = "B2"
      description = "Upper-Intermediate - вы уверенно общаетесь на английском, понимаете сложные тексты."
    } else if (percentage >= 60) {
      level = "B1"
      description = "Intermediate - вы можете общаться на повседневные темы, понимаете основную идею текстов."
    } else if (percentage >= 40) {
      level = "A2"
      description = "Elementary - вы владеете базовыми навыками общения на простые темы."
    }

    return { level, description }
  }

  function showResults() {
    const { level, description } = calculateLevel()

    // Update result screen
    testPopup.querySelector("#userLevel").textContent = level
    testPopup.querySelector("#levelDescription").textContent = description

    // Hide questions, show results
    questions.forEach((q) => q.classList.remove("active"))
    resultScreen.classList.add("active")

    // Hide navigation buttons
    testPopup.querySelector(".level-test__navigation").style.display = "none"
  }

  // Previous button
  if (prevButton) {
    prevButton.addEventListener("click", () => {
      if (currentQuestion > 1) {
        currentQuestion--
        showQuestion(currentQuestion)
      }
    })
  }

  // Next button
  if (nextButton) {
    nextButton.addEventListener("click", () => {
      // Save current answer
      const currentRadio = testPopup.querySelector(
        `.level-test__question[data-question="${currentQuestion}"] input[type="radio"]:checked`,
      )
      if (currentRadio) {
        answers[currentRadio.name] = currentRadio.value
      }

      if (currentQuestion < totalQuestions) {
        currentQuestion++
        showQuestion(currentQuestion)
      }
    })
  }

  // Finish button
  if (finishButton) {
    finishButton.addEventListener("click", () => {
      // Save last answer
      const currentRadio = testPopup.querySelector(
        `.level-test__question[data-question="${currentQuestion}"] input[type="radio"]:checked`,
      )
      if (currentRadio) {
        answers[currentRadio.name] = currentRadio.value
      }

      showResults()
    })
  }

  // Handle result form submission
  const resultForm = testPopup.querySelector(".level-test__form")
  if (resultForm) {
    resultForm.addEventListener("submit", (e) => {
      e.preventDefault()

      const submitButton = resultForm.querySelector('button[type="submit"]')
      const originalText = submitButton.textContent
      submitButton.textContent = "Отправка..."
      submitButton.disabled = true

      // Simulate form submission
      setTimeout(() => {
        submitButton.textContent = "Отправлено!"

        setTimeout(() => {
          closeTestPopup()
          resetTest()
          submitButton.textContent = originalText
          submitButton.disabled = false
          resultForm.reset()

          // Show success message
          alert("Спасибо! Ваши результаты отправлены. Мы свяжемся с вами в ближайшее время.")
        }, 1500)
      }, 1500)
    })
  }

  // Initialize
  showQuestion(1)
}
